module.exports = __webpack_public_path__ + "img/des-btn.c401ccdc.png";